<div class="suggestion-card comment-card" [class.highlighted]="highlighted" (click)="onCardClick($event)">
  @if (isDraft) {
    <span class="comment-card-status-pill">{{ 'EDITOR.COMMENTS.DRAFT_STATUS' | translate }}</span>
  }
  @if (authorName !== null) {
    <app-suggestion-meta class="suggestion-card-header" [authorName]="authorName" [createdAtRelative]="createdAtRelative"></app-suggestion-meta>
  }
  <div class="suggestion-card-diff comment-card-quote" [class.comment-card-quote-orphaned]="orphaned">
    <span class="suggestion-card-diff-label">
      @if (orphaned) {
        {{ 'EDITOR.COMMENTS.ORPHANED' | translate }}
      } @else {
        {{ 'EDITOR.COMMENTS.QUOTED_LABEL' | translate }}
      }
    </span>
    @if (!orphaned) {
      <span class="suggestion-card-diff-text comment-card-quote-text">{{ quotedText }}</span>
    }
  </div>
  @if (firstCommentBody !== null) {
    <div class="comment-card-first-comment">{{ firstCommentBody }}</div>
  }
  <div class="suggestion-card-actions">
    @if (canResolve && !isDraft) {
      <button type="button" class="suggestion-card-button suggestion-card-button-accept" (click)="onResolve()">
        <mat-icon>check</mat-icon>
        <span>{{ 'EDITOR.COMMENTS.RESOLVE' | translate }}</span>
      </button>
    }
    @if (isDraft && !hasComments) {
      <button type="button" class="suggestion-card-button suggestion-card-button-reject" (click)="onDiscard()">
        <mat-icon>close</mat-icon>
        <span>{{ 'EDITOR.TRACK_CHANGES.SIDEBAR.ACTION_CANCEL' | translate }}</span>
      </button>
    }
    @if (!orphaned) {
      <button type="button" class="suggestion-card-button suggestion-card-button-view" (click)="onView()">
        <mat-icon>visibility</mat-icon>
        <span>{{ 'EDITOR.TRACK_CHANGES.SIDEBAR.ACTION_VIEW' | translate }}</span>
      </button>
    }
  </div>
  <div class="suggestion-card-actions-divider"></div>
  <app-thread-comments
    [thread]="thread"
    [currentUser]="currentUser"
    [canPostComment]="canPostComment"
    [isDraft]="isDraft"
    [hideFirstComment]="true"
    (submitComment)="onSubmitComment($event)"
  ></app-thread-comments>
</div>
